const SHARED_HUB_LINKS = [
  { label: "All PDF Tools", href: "/tools" },
  { label: "Batch PDF Tools", href: "/batch-tools" },
  { label: "Merge PDF", href: "/tools/merge" },
  { label: "Compress PDF", href: "/tools/compress" },
  { label: "Split PDF", href: "/tools/split" },
];

const toolSources = [
  { path: "/tools", name: "PDF Tools", description: "Browse the full library of privacy-first PDF tools that run in your browser without uploads.", family: "hub", category: "hub" },
  { path: "/batch-tools", name: "Batch PDF Tools", description: "Browse batch processing tools for compressing, splitting, securing, and converting multiple PDFs at once.", family: "hub", category: "hub" },
  { path: "/tools/edit-pdf", name: "Edit PDF", description: "Open the visual editor to add text, shapes, redactions, and headers or footers locally.", family: "tool", category: "layout" },
  { path: "/tools/edit-pdf-layout", name: "Edit PDF Layout", description: "Adjust crop, page size, grayscale, page numbers, and layout settings in one browser-based workflow.", family: "tool", category: "layout" },
  { path: "/tools/edit-layout", name: "Edit PDF Layout Hub", description: "Explore layout-focused PDF tools for page size, margins, contrast, and other visual edits.", family: "tool", category: "layout" },
  { path: "/tools/merge", name: "Merge PDF", description: "Combine multiple PDFs into one document without uploads.", family: "tool", category: "combine" },
  { path: "/tools/rearrange", name: "Rearrange PDF", description: "Reorder, rotate, and delete pages within a PDF directly in your browser.", family: "tool", category: "layout" },
  { path: "/tools/esign-pdf", name: "eSign PDF", description: "Sign PDF documents with an electronic signature locally on your device.", family: "tool", category: "security" },
  { path: "/tools/convert/image-to-pdf", name: "Image to PDF", description: "Convert JPG and PNG images into a single PDF file without a server upload.", family: "tool", category: "combine" },
  { path: "/tools/split", name: "Split PDF", description: "Extract page ranges into new PDFs directly in your browser.", family: "tool", category: "split" },
  { path: "/tools/watermark", name: "Watermark PDF", description: "Apply text watermarks locally on selected pages and export a clean PDF.", family: "tool", category: "security" },
  { path: "/tools/encrypt", name: "Encrypt PDF", description: "Add a password and permissions to a PDF locally in your browser.", family: "tool", category: "security" },
  { path: "/tools/decrypt", name: "Decrypt PDF", description: "Remove a PDF password locally in your browser.", family: "tool", category: "security" },
  { path: "/tools/convert/pdf-to-image", name: "PDF to Image", description: "Render PDF pages as PNG or JPG images on-device.", family: "tool", category: "export" },
  { path: "/tools/convert/pdf-to-word", name: "PDF to Word", description: "Extract text into a DOCX file in the browser without cloud processing.", family: "tool", category: "export" },
  { path: "/tools/convert/pdf-to-html", name: "PDF to HTML", description: "Convert PDF pages into clean HTML while keeping the workflow local.", family: "tool", category: "export" },
  { path: "/tools/crop", name: "Crop PDF", description: "Visually crop page boundaries on one or all pages in your browser.", family: "tool", category: "layout" },
  { path: "/tools/remove-pages", name: "Remove Pages from PDF", description: "Delete pages by entering ranges and previewing the result before downloading.", family: "tool", category: "cleanup" },
  { path: "/tools/page-numbers", name: "Add Page Numbers to PDF", description: "Overlay page numbers with your preferred style and position locally.", family: "tool", category: "formatting" },
  { path: "/tools/compress", name: "Compress PDF", description: "Reduce PDF size with browser-based compression and no file uploads.", family: "tool", category: "file-size" },
  { path: "/tools/epub-to-pdf", name: "EPUB to PDF", description: "Convert EPUB books to PDF documents directly in your browser.", family: "tool", category: "convert" },
  { path: "/tools/pdf-to-epub", name: "PDF to EPUB", description: "Convert PDFs into reflowable EPUB files with a local-first workflow.", family: "tool", category: "convert" },
  { path: "/tools/word-to-pdf", name: "Word to PDF", description: "Convert DOCX documents to PDF locally using browser-based processing.", family: "tool", category: "convert" },
  { path: "/tools/markdown-to-pdf", name: "Markdown to PDF", description: "Turn Markdown files into styled PDFs locally in your browser.", family: "tool", category: "convert" },
  { path: "/tools/invoice-generator", name: "Invoice Generator PDF", description: "Create polished PDF invoices with totals, branding, and signatures on-device.", family: "tool", category: "export" },
  { path: "/tools/qrcode-generator", name: "QR and Barcode to PDF", description: "Generate batch QR codes and barcodes for printing labels, cards, and sheets.", family: "tool", category: "export" },
  { path: "/tools/csv-to-pdf", name: "CSV to PDF", description: "Convert raw CSV data into styled PDF reports instantly in your browser.", family: "tool", category: "export" },
  { path: "/tools/extract-images", name: "Extract Images from PDF", description: "Extract embedded images from PDFs and download the results as a ZIP file.", family: "tool", category: "cleanup" },
  { path: "/tools/split-by-size", name: "Split PDF by Size", description: "Split large PDFs into smaller chunks based on a maximum file size.", family: "tool", category: "split" },
  { path: "/tools/extract-form-data", name: "Extract Form Data from PDF", description: "Extract form field values from PDF forms and export the results as JSON.", family: "tool", category: "export" },
  { path: "/tools/enhance-pdf", name: "Enhance PDF", description: "Sharpen text, improve readability, and clean scanned backgrounds locally.", family: "tool", category: "edit" },
  { path: "/tools/flatten-pdf", name: "Flatten PDF", description: "Flatten forms and annotation layers to create a stable, non-editable PDF.", family: "tool", category: "edit" },
  { path: "/tools/ocr-pdf", name: "OCR PDF", description: "Extract text from scanned PDFs using browser-based OCR.", family: "tool", category: "export" },
  { path: "/tools/extract-text-ocr", name: "Extract Text with OCR", description: "Extract text from image-heavy PDFs using OCR in a worker-powered workflow.", family: "tool", category: "export" },
  { path: "/tools/create-pdf", name: "Create PDF", description: "Create PDF documents from scratch with rich text styling in the browser.", family: "tool", category: "convert" },
  { path: "/tools/pdf-to-zip", name: "PDF to ZIP", description: "Export each PDF page as an image and download everything in a ZIP archive.", family: "tool", category: "export" },
  { path: "/tools/redact-text", name: "Redact Text in PDF", description: "Find and redact sensitive text in PDF documents before sharing.", family: "tool", category: "security" },
  { path: "/tools/mail-merge", name: "Mail Merge PDF", description: "Fill PDF templates with CSV data to create personalized documents in bulk.", family: "tool", category: "combine" },
  { path: "/tools/header-footer", name: "Add Header and Footer to PDF", description: "Add custom headers, footers, dates, and page numbers locally.", family: "tool", category: "formatting" },
  { path: "/tools/increase-pdf-size", name: "Increase PDF Size", description: "Upscale or re-render PDFs when a larger output file is required.", family: "tool", category: "file-size" },
  { path: "/tools/link-manager", name: "PDF Link Manager", description: "Inspect and edit interactive links inside a PDF document.", family: "tool", category: "edit" },
  { path: "/tools/edit/page-size", name: "Change PDF Page Size", description: "Resize PDF pages for print, screen, or archive requirements.", family: "tool", category: "layout" },
  { path: "/tools/edit/margins", name: "Adjust PDF Margins", description: "Fine-tune page margins and printable area directly in the browser.", family: "tool", category: "layout" },
  { path: "/tools/edit/contrast", name: "Adjust PDF Contrast", description: "Improve visibility by re-rendering light and dark PDFs with new contrast settings.", family: "tool", category: "layout" },
  { path: "/tools/form-builder", name: "PDF Form Builder", description: "Create or update PDF forms with editable fields and downloadable output.", family: "tool", category: "edit" },
  { path: "/tools/pdf-diff", name: "PDF Diff", description: "Compare PDFs visually and textually to detect document changes.", family: "tool", category: "export" },
  { path: "/tools/pdf-to-excel", name: "PDF to Excel", description: "Extract tables from PDFs into spreadsheet-ready CSV or Excel-style output.", family: "tool", category: "export" },
  { path: "/tools/sign-fill", name: "Sign and Fill PDF", description: "Fill forms, place signatures, and download a completed PDF locally.", family: "tool", category: "security" },
  { path: "/tools/pdf-translator", name: "Translate PDF", description: "Translate PDF text locally and export translated content.", family: "tool", category: "export" },
  { path: "/tools/pdf-to-pptx", name: "PDF to PowerPoint", description: "Convert PDF pages into presentation slides in your browser.", family: "tool", category: "convert" },
  { path: "/tools/excel-to-pdf", name: "Excel to PDF", description: "Convert CSV and XLSX data into PDF tables without leaving the browser.", family: "tool", category: "convert" },
  { path: "/tools/html-to-pdf", name: "HTML to PDF", description: "Turn HTML content into a styled PDF with a local rendering pipeline.", family: "tool", category: "convert" },
  { path: "/tools/pdf-repair", name: "PDF Repair", description: "Attempt to repair corrupted PDFs by rebuilding the document locally.", family: "tool", category: "cleanup" },
  { path: "/tools/page-extractor", name: "Page Extractor PDF", description: "Select and extract specific PDF pages into a new downloadable file.", family: "tool", category: "split" },
  { path: "/tools/add-bookmarks", name: "Add Bookmarks to PDF", description: "Add bookmarks and a table of contents to a PDF locally.", family: "tool", category: "edit" },
  { path: "/tools/pdf-metadata", name: "PDF Metadata Editor", description: "View and edit title, author, keywords, and document metadata locally.", family: "tool", category: "edit" },
  { path: "/tools/pdf-permissions", name: "PDF Permission Manager", description: "Set granular access controls for printing, copying, editing, and more.", family: "tool", category: "security" },
  { path: "/tools/pdf-security-audit", name: "PDF Security Audit", description: "Scan a PDF for encryption, scripts, embedded files, and risk signals.", family: "tool", category: "security" },
  { path: "/tools/pdf-sanitizer", name: "PDF Sanitizer", description: "Remove JavaScript, embedded files, auto-actions, and metadata for safer sharing.", family: "tool", category: "security" },
  { path: "/tools/pdf-signer", name: "PDF Signer", description: "Digitally sign PDF files with a certificate and download the signed result.", family: "tool", category: "security" },
  { path: "/tools/dynamic-watermark", name: "Dynamic Watermark PDF", description: "Apply watermark patterns with dynamic variables across PDF pages.", family: "tool", category: "security" },
  { path: "/tools/pdf-a-converter", name: "PDF/A Converter", description: "Convert PDFs into archive-friendly PDF/A output in a browser workflow.", family: "tool", category: "convert" },
  { path: "/tools/pdf-compare", name: "PDF Compare", description: "Compare two PDF files side by side and download a difference report.", family: "tool", category: "export" },
  { path: "/tools/pdf-to-webp", name: "PDF to WebP", description: "Convert PDF pages into compact WebP images locally.", family: "tool", category: "convert" },
  { path: "/tools/webp-to-pdf", name: "WebP to PDF", description: "Convert WebP images into a downloadable PDF without server uploads.", family: "tool", category: "convert" },
  { path: "/tools/svg-to-pdf", name: "SVG to PDF", description: "Convert SVG vector artwork into clean PDF output in the browser.", family: "tool", category: "convert" },
  { path: "/tools/inspector", name: "PDF Inspector", description: "Inspect document details, page structure, and metadata before editing or exporting.", family: "tool", category: "cleanup" },
  { path: "/tools/ai/chat", name: "Chat with PDF", description: "Upload a PDF and ask questions about its content using an AI-assisted browser workflow.", family: "ai", category: "ai" },
  { path: "/tools/ai/quiz", name: "Quiz Generator from PDF", description: "Generate quiz questions from PDF content and download the results locally.", family: "ai", category: "ai" },
  { path: "/tools/ai/timeline", name: "Timeline Generator from PDF", description: "Extract chronological events from PDFs and turn them into a clear timeline.", family: "ai", category: "ai" },
  { path: "/tools/ai/summarize", name: "Summarize PDF", description: "Generate concise summaries from a PDF with AI support while keeping files local.", family: "ai", category: "ai" },
  { path: "/tools/ai/keypoints", name: "PDF Key Points Extractor", description: "Pull out the most important takeaways from a PDF using AI assistance.", family: "ai", category: "ai" },
  { path: "/tools/ai/flashcards", name: "Flashcard Generator from PDF", description: "Turn PDF content into study flashcards for review and export.", family: "ai", category: "ai" },
  { path: "/tools/ai/studyguide", name: "Study Guide Generator from PDF", description: "Create a structured study guide from PDF material with AI help.", family: "ai", category: "ai" },
  { path: "/batch-tools/stamp", name: "Batch Stamp PDF", description: "Upload multiple PDFs, position a stamp visually, and apply it to all files.", family: "batch", category: "automation" },
  { path: "/batch-tools/dynamic-stamp", name: "Batch Dynamic Stamp PDF", description: "Add dynamic page numbers, dates, and filenames to multiple PDFs.", family: "batch", category: "automation" },
  { path: "/batch-tools/page-numbers", name: "Batch Page Numbers PDF", description: "Add page numbers to multiple PDFs with consistent formatting.", family: "batch", category: "automation" },
  { path: "/batch-tools/bates-numbering", name: "Bates Numbering PDF", description: "Apply sequential Bates numbers to PDFs for legal workflows.", family: "batch", category: "legal" },
  { path: "/batch-tools/metadata", name: "Batch Metadata Cleaner PDF", description: "Strip metadata from multiple PDFs for privacy and compliance.", family: "batch", category: "legal" },
  { path: "/batch-tools/redact", name: "Batch Redact PDF", description: "Redact sensitive patterns like emails, phones, and IDs in multiple PDFs.", family: "batch", category: "legal" },
  { path: "/batch-tools/encrypt", name: "Batch Encrypt PDF", description: "Password-protect multiple PDFs with one browser-based batch workflow.", family: "batch", category: "security" },
  { path: "/batch-tools/decrypt", name: "Batch Decrypt PDF", description: "Remove password protection from multiple PDFs in one session.", family: "batch", category: "security" },
  { path: "/batch-tools/compress", name: "Batch Compress PDF", description: "Compress multiple PDFs at once with local quality presets.", family: "batch", category: "optimize" },
  { path: "/batch-tools/flatten", name: "Batch Flatten PDF", description: "Flatten forms and annotations in multiple PDF files.", family: "batch", category: "optimize" },
  { path: "/batch-tools/split", name: "Batch Split PDF", description: "Split multiple PDFs by page count, ranges, or individual pages.", family: "batch", category: "organize" },
  { path: "/batch-tools/layout", name: "Batch Layout Changer PDF", description: "Rotate, crop, and adjust layouts for multiple PDFs.", family: "batch", category: "organize" },
  { path: "/batch-tools/rotate", name: "Batch Rotate PDF", description: "Rotate pages in multiple PDFs by 90, 180, or 270 degrees.", family: "batch", category: "organize" },
  { path: "/batch-tools/extract-text", name: "Batch Extract Text PDF", description: "Extract text from multiple PDFs and download the results as text files.", family: "batch", category: "convert" },
  { path: "/batch-tools/pdf-to-image", name: "Batch PDF to Image", description: "Convert PDF pages to PNG or JPEG images across many files.", family: "batch", category: "convert" },
  { path: "/batch-tools/pdf-to-pptx", name: "Batch PDF to PowerPoint", description: "Convert PDF pages to presentation slides for many files at once.", family: "batch", category: "convert" },
  { path: "/batch-tools/excel-to-pdf", name: "Batch Excel to PDF", description: "Convert multiple CSV or spreadsheet files into formatted PDFs.", family: "batch", category: "convert" },
  { path: "/batch-tools/html-to-pdf", name: "Batch HTML to PDF", description: "Convert multiple HTML files to PDFs in one local workflow.", family: "batch", category: "convert" },
  { path: "/batch-tools/pdf-repair", name: "Batch PDF Repair", description: "Attempt to fix multiple corrupted PDFs by re-serializing them locally.", family: "batch", category: "optimize" },
  { path: "/batch-tools/page-extractor", name: "Batch Page Extractor PDF", description: "Extract specific page ranges from multiple PDFs.", family: "batch", category: "organize" },
  { path: "/batch-tools/add-bookmarks", name: "Batch Add Bookmarks PDF", description: "Add bookmarks and TOC structures to multiple PDFs at once.", family: "batch", category: "organize" },
  { path: "/batch-tools/metadata-editor", name: "Batch Metadata Editor PDF", description: "Edit or clear metadata across multiple PDFs in one batch.", family: "batch", category: "legal" },
  { path: "/batch-tools/permission-manager", name: "Batch Permission Manager PDF", description: "Apply permission restrictions to multiple PDFs at once.", family: "batch", category: "security" },
  { path: "/batch-tools/security-audit", name: "Batch PDF Security Audit", description: "Scan multiple PDFs for security vulnerabilities and risky document features.", family: "batch", category: "security" },
  { path: "/batch-tools/sanitizer", name: "Batch PDF Sanitizer", description: "Remove JavaScript, embedded files, and auto-actions from multiple PDFs.", family: "batch", category: "security" },
  { path: "/batch-tools/extract-images", name: "Batch Extract Images from PDF", description: "Extract embedded images from multiple PDF files simultaneously.", family: "batch", category: "organize" },
  { path: "/batch-tools/split-by-size", name: "Batch Split PDF by Size", description: "Split multiple PDFs into smaller files based on a maximum size.", family: "batch", category: "organize" },
  { path: "/batch-tools/pdf-to-webp", name: "Batch PDF to WebP", description: "Convert pages of multiple PDFs into WebP images.", family: "batch", category: "convert" },
  { path: "/batch-tools/webp-to-pdf", name: "Batch WebP to PDF", description: "Convert multiple WebP images into separate PDF documents.", family: "batch", category: "convert" },
  { path: "/batch-tools/svg-to-pdf", name: "Batch SVG to PDF", description: "Convert multiple SVG files into separate PDF documents.", family: "batch", category: "convert" },
  { path: "/batch-tools/epub-to-pdf", name: "Batch EPUB to PDF", description: "Convert a folder of EPUB books into independent PDF files.", family: "batch", category: "convert" },
  { path: "/batch-tools/pdf-to-epub", name: "Batch PDF to EPUB", description: "Extract text from multiple PDFs and generate separate EPUB files.", family: "batch", category: "convert" },
  { path: "/batch-tools/markdown-to-pdf", name: "Batch Markdown to PDF", description: "Generate PDFs for multiple Markdown documents in a single local pass.", family: "batch", category: "convert" },
  { path: "/batch-tools/ocr", name: "Batch OCR PDF", description: "Run OCR across multiple PDFs and export searchable results.", family: "batch", category: "convert" },
  { path: "/batch-tools/pdf-signer", name: "Batch PDF Signer", description: "Digitally sign multiple PDF documents with one certificate workflow.", family: "batch", category: "security" },
  { path: "/batch-tools/dynamic-watermark", name: "Batch Dynamic Watermark PDF", description: "Apply dynamic anti-piracy watermarks across many PDF files.", family: "batch", category: "security" },
];

export const CATEGORY_META = {
  combine: { title: "Merge & Combine PDFs", desc: "Tools to merge, assemble, and stitch multiple PDF files together.", icon: "📚" },
  layout: { title: "PDF Layout & Pages", desc: "Adjust margins, crop, rearrange, and resize PDF pages.", icon: "📏" },
  split: { title: "Split & Extract PDFs", desc: "Divide large PDFs into smaller chunks or extract specific pages.", icon: "✂️" },
  security: { title: "PDF Security & Redaction", desc: "Encrypt, redact, sanitize, and digitally sign your sensitive documents.", icon: "🔒" },
  export: { title: "Export from PDF", desc: "Extract text, images, form data, and tables from PDF files.", icon: "📤" },
  cleanup: { title: "Clean Up PDFs", desc: "Remove unwanted pages, images, and metadata from your files.", icon: "🧹" },
  formatting: { title: "Format PDFs", desc: "Add headers, footers, page numbers, and bates stamps.", icon: "📝" },
  "file-size": { title: "Optimize PDF Size", desc: "Compress and reduce PDF file sizes for easier sharing.", icon: "🗜️" },
  convert: { title: "Convert to & from PDF", desc: "Convert Word, Excel, Images, HTML, and Markdown to PDF, or vice versa.", icon: "🔄" },
  edit: { title: "Edit PDF Content", desc: "Visually edit, annotate, and modify PDF content directly.", icon: "✍️" },
  automation: { title: "Automate PDF Workflows", desc: "Batch process and automate repetitive PDF tasks.", icon: "⚙️" },
  legal: { title: "Legal PDF Tools", desc: "Bates numbering, redaction, and metadata editing for legal professionals.", icon: "⚖️" },
  organize: { title: "Organize PDFs", desc: "Reorder, bookmarks, and structural organization tools.", icon: "📁" },
  ai: { title: "AI PDF Tools", desc: "Chat with PDFs, summarize, translate, and generate quizzes.", icon: "🤖" },
};

export const CATEGORY_LABELS = Object.fromEntries(
  Object.entries(CATEGORY_META).map(([k, v]) => [k, v.title])
);

const TIER_ONE_PATHS = new Set([
  "/tools",
  "/batch-tools",
  "/tools/merge",
  "/tools/compress",
  "/tools/split",
  "/tools/remove-pages",
  "/tools/edit-pdf",
  "/tools/convert/pdf-to-word",
  "/tools/word-to-pdf",
  "/merge-pdf-locally",
  "/compress",
  "/remove-pdf-pages-offline",
]);

const TIER_TWO_CATEGORIES = new Set([
  "layout",
  "convert",
  "security",
  "cleanup",
  "export",
  "edit",
  "file-size",
]);

const escapeRegExp = (value) =>
  value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const slugToWords = (value) =>
  value
    .split("/")
    .filter(Boolean)
    .pop()
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

const inferTier = (source) => {
  if (TIER_ONE_PATHS.has(source.path)) return "core";
  if (source.family === "batch" || source.family === "ai") return "broad";
  if (TIER_TWO_CATEGORIES.has(source.category)) return "secondary";
  return "secondary";
};

const inferSearchIntent = (source) => {
  if (source.family === "hub") return "informational";
  if (source.family === "ai") return "commercial";
  return "transactional";
};

const inferSchemaType = (source) => {
  if (source.family === "hub") return "CollectionPage";
  if (
    source.path.includes("for-") ||
    source.path.includes("court") ||
    source.path.includes("email") ||
    source.path.includes("printing")
  ) {
    return "HowTo";
  }
  return "SoftwareApplication";
};

const buildPrimaryKeyword = (source) => {
  const slugWords = slugToWords(source.path).toLowerCase();
  if (source.family === "hub") return source.name.toLowerCase();
  if (source.family === "batch") return `batch ${slugWords}`;
  return slugWords;
};

const buildSecondaryKeywords = (source) => {
  const base = slugToWords(source.path).toLowerCase();
  const items = [
    `${base} online`,
    `${base} free`,
    `${base} browser tool`,
    "privacy-first pdf tools",
  ];

  if (source.family === "batch") {
    items.push(`bulk ${base}`, `${base} workflow`);
  }

  if (source.family === "ai") {
    items.push(`${base} ai`, `pdf ${base}`);
  }

  return [...new Set(items)];
};

const buildUseCases = (source) => {
  const family = source.family;
  const category = source.category;

  if (family === "batch") {
    return [
      "Apply one PDF workflow to many files in a single session.",
      "Reduce repeated manual work for operations, legal, and document admin teams.",
      "Keep multi-file processing organized with a clearer path from upload to download.",
    ];
  }

  if (family === "ai") {
    return [
      "Summarize, question, and study PDF content after the document is loaded.",
      "Turn reference material into quizzes, flashcards, and notes more quickly.",
      "Support review and learning workflows around long PDF documents.",
    ];
  }

  if (category === "security") {
    return [
      "Prepare PDFs for safer external sharing.",
      "Inspect permissions, signatures, metadata, or risky embedded features.",
      "Reduce document exposure before delivery to clients, teams, or portals.",
    ];
  }

  if (category === "convert" || category === "export") {
    return [
      "Move content from PDF into editable or reusable output formats.",
      "Support collaboration, publishing, and document reuse workflows.",
      "Export files in a format that fits the next step of the task.",
    ];
  }

  return [
    "Complete the task directly in the browser with fewer workflow steps.",
    "Keep document organization clear before downloading the final output.",
    "Move from upload to final file quickly with related next-step links.",
  ];
};

const buildComparisonLinks = (source) => {
  if (source.path === "/tools/merge") {
    return [
      { label: "Merge PDF vs Rearrange PDF", href: "/blog/merge-pdf-vs-rearrange-pdf" },
    ];
  }
  if (source.path === "/tools/ocr-pdf" || source.path === "/tools/extract-text-ocr") {
    return [
      { label: "OCR PDF vs Extract Text", href: "/blog/ocr-pdf-vs-extract-text" },
    ];
  }
  if (source.path === "/tools/pdf-sanitizer" || source.path === "/tools/pdf-security-audit") {
    return [
      { label: "PDF Sanitizer vs Security Audit", href: "/blog/pdf-sanitizer-vs-security-audit" },
    ];
  }
  if (source.path === "/tools/convert/pdf-to-word" || source.path === "/tools/convert/pdf-to-html") {
    return [
      { label: "PDF to Word vs PDF to HTML", href: "/blog/pdf-to-word-vs-pdf-to-html" },
    ];
  }
  return [];
};

const makeH1 = (name, family) => {
  if (family === "hub") {
    return name === "Batch PDF Tools"
      ? "Batch PDF Tools Online Free"
      : "PDF Tools Online Free";
  }
  return `${name} Online Free`;
};

const makeKeywords = (name, path) => {
  const slugWords = slugToWords(path).toLowerCase();
  return [
    name.toLowerCase(),
    `${slugWords} online`,
    `${slugWords} free`,
    "pdf tools",
    "client side pdf",
    "no upload pdf tool",
  ].join(", ");
};

const makeStepTwo = (source) => {
  const lower = `${source.name} ${source.path}`.toLowerCase();
  if (lower.includes("merge")) return "Arrange";
  if (lower.includes("split")) return "Configure";
  if (lower.includes("compress")) return "Configure";
  if (lower.includes("compare") || lower.includes("diff")) return "Analyze";
  if (lower.includes("chat") || lower.includes("quiz") || lower.includes("study") || lower.includes("flashcard") || lower.includes("summary") || lower.includes("key points") || lower.includes("timeline")) {
    return "Analyze";
  }
  if (lower.includes("batch")) return "Configure";
  return "Configure";
};

const buildGuideParagraphs = (source) => {
  const primaryKeyword = buildPrimaryKeyword(source);
  const useCases = buildUseCases(source);
  const family = source.family;
  const categoryLabel = CATEGORY_LABELS[source.category] || "PDF";

  if (family === "batch") {
    return [
      `${source.name} is designed for users who need to run the same ${categoryLabel.toLowerCase()} workflow across many files in one session. ${source.description} Instead of repeating the same action document by document, this route helps visitors configure the task once, apply it across a folder or selection, and download the results in a cleaner batch workflow.`,
      `This page targets batch-intent searches around ${primaryKeyword}. The copy focuses on what users need before they start: what kind of input works best, what output to expect, and why this route is more efficient than reopening a single-file tool over and over again.`,
      `${useCases[0]} ${useCases[1]} ${useCases[2]} The result is a route that can rank for long-tail batch queries while still behaving like a practical multi-file document utility.`,
    ];
  }

  if (family === "ai") {
    return [
      `${source.name} is built for PDF analysis and study workflows where visitors want more than a basic file utility. ${source.description} This route explains the task clearly before the interactive tool loads, helping users understand when AI assistance makes sense and what kind of output the workflow can generate.`,
      `The page is intentionally different from a pure conversion or editing route. It focuses on extracting meaning, generating study material, or helping a reader work through long PDF content. That creates a more distinct search target and reduces overlap with standard file-manipulation pages.`,
      `${useCases[0]} ${useCases[1]} ${useCases[2]} It also links visitors back into the broader PDF tool ecosystem when they need cleanup, conversion, or organization before analysis.`,
    ];
  }

  if (source.category === "security") {
    return [
      `${source.name} helps visitors handle document privacy, permissions, signatures, or risk review with a browser-based workflow. ${source.description} This page is optimized for users who care about safer sharing, compliance preparation, and clearer control over what a PDF contains before it leaves their device.`,
      `Security-focused PDF searches are usually high-intent and task-specific. The page therefore explains what the tool does, what kinds of files benefit most from the workflow, and how it fits into a larger document review process instead of acting like a thin landing page with only a button.`,
      `${useCases[0]} ${useCases[1]} ${useCases[2]} Those details improve both user confidence and topical differentiation across the broader set of tool pages.`,
    ];
  }

  if (source.category === "convert" || source.category === "export") {
    return [
      `${source.name} is designed for visitors who need to move PDF content into another usable format without unnecessary steps. ${source.description} The route clarifies the input, the output, and the situations where this type of conversion is most useful before the user interacts with the tool itself.`,
      `Conversion pages need stronger explanatory content because search intent often depends on what happens after export. This page therefore covers likely next steps such as editing, publishing, sharing, or follow-up conversion so the route is more useful than a bare converter shell.`,
      `${useCases[0]} ${useCases[1]} ${useCases[2]} That gives the page a better chance to rank for practical conversion queries while staying connected to adjacent PDF workflows.`,
    ];
  }

  return [
    `${source.name} is a privacy-first ${categoryLabel.toLowerCase()} workflow built for users who want a direct browser-based route from upload to download. ${source.description} The page explains the task before interaction begins so visitors know what the tool is for, what kind of output to expect, and how this route fits into the wider PDF workflow.`,
    `The content is intentionally static enough to help search engines understand the page before JavaScript takes over, but practical enough to help real users decide whether this is the right route for the job. That balance matters for broad index coverage because each tool page needs to stand on its own instead of relying on duplicated generic copy.`,
    `${useCases[0]} ${useCases[1]} ${useCases[2]} Combined with related links and route-specific FAQs, that gives the page a clearer purpose and better differentiation across the full tool inventory.`,
  ];
};

const buildFaqs = (source) => {
  const lowerName = source.name.toLowerCase();
  return [
    {
      question: `How does ${source.name} work on this page?`,
      answer: `This page follows a simple browser workflow: upload the required file or files, configure the ${lowerName} settings, and download the finished output. The goal is to keep the process direct and understandable without forcing a server upload as the default path.`,
    },
    {
      question: `Can I use ${source.name} for sensitive documents?`,
      answer: `The workflow is designed around local-first processing so private PDFs, study notes, internal reports, contracts, and other sensitive files can be handled with better control. You should still review the final output before sharing it externally.`,
    },
    {
      question: `What kind of files should I upload for ${source.name}?`,
      answer: `Use the file type expected by the tool interface on this route. In most cases that means PDF input, but some conversion routes accept related formats such as images, Markdown, HTML, EPUB, spreadsheet files, or certificate files depending on the task.`,
    },
    {
      question: `What should I do after using ${source.name}?`,
      answer: `After downloading the result, many users move to a related PDF step such as compressing the output, merging it with other files, extracting pages, securing the document, or converting it into another format. The related links below are there to support that next step.`,
    },
    {
      question: `What is ${source.name} best for?`,
      answer: buildUseCases(source).join(" "),
    },
  ];
};

const buildRobots = (source) => (source.noindex ? "noindex,follow" : "index,follow");

const createBaseRoute = (source) => ({
  path: source.path,
  name: source.name,
  description: source.description,
  family: source.family,
  category: source.category,
  tier: inferTier(source),
  searchIntent: inferSearchIntent(source),
  primaryKeyword: buildPrimaryKeyword(source),
  secondaryKeywords: buildSecondaryKeywords(source),
  useCases: buildUseCases(source),
  schemaType: inferSchemaType(source),
  comparisonLinks: buildComparisonLinks(source),
  h1: makeH1(source.name, source.family),
  title: `${makeH1(source.name, source.family)} | PDFWorkSpace`,
  metaDescription: source.description,
  keywords: makeKeywords(source.name, source.path),
  canonicalPath: source.path,
  guideParagraphs: buildGuideParagraphs(source),
  steps: [
    {
      title: "Upload",
      description: `Upload the file or files needed for ${source.name.toLowerCase()} and wait for the browser to prepare the workspace.`,
    },
    {
      title: makeStepTwo(source),
      description: `Adjust the settings for ${source.name.toLowerCase()}, review the preview or file list, and confirm the configuration before export.`,
    },
    {
      title: "Download",
      description: `Generate the final output and download the processed result directly from the browser when the task completes.`,
    },
  ],
  faqs: buildFaqs(source),
  relatedLinks: [],
  robots: buildRobots(source),
  indexable: !source.noindex,
});

const allBaseRoutes = toolSources.map(createBaseRoute);

for (const route of allBaseRoutes) {
  const related = allBaseRoutes
    .filter((candidate) => candidate.path !== route.path)
    .filter((candidate) => {
      if (candidate.family === "hub") return true;
      if (candidate.category === route.category) return true;
      if (candidate.family === route.family) return true;
      return false;
    })
    .slice(0, 4)
    .map((candidate) => ({ label: candidate.name, href: candidate.path }));

  route.relatedLinks =
    related.length > 0 ? related : SHARED_HUB_LINKS.filter((link) => link.href !== route.path).slice(0, 4);
}

export const TOOL_SEO_ROUTES = allBaseRoutes;
export const TOOL_SEO_ROUTE_MAP = Object.fromEntries(
  TOOL_SEO_ROUTES.map((route) => [route.path, route]),
);

export const TOOL_SEO_INDEXABLE_ROUTES = TOOL_SEO_ROUTES.filter(
  (route) => route.indexable,
).map((route) => route.path);

export const CORE_SEO_ROUTES = [
  "/",
  "/merge-pdf",
  "/compress-pdf",
  "/split-pdf",
  "/pdf-to-word",
  "/word-to-pdf",
  "/faq",
  "/about-privacy",
  "/privacy",
  "/terms",
  "/ai-key-guide",
];

import { PROGRAMMATIC_SEO_PATHS } from "./programmaticSeoData.ts";
import { COMPARISON_SEO_PATHS } from "./comparisonSeoData.ts";
import { ALTERNATIVE_SEO_PATHS } from "./alternativesSeoData.ts";

export const CATEGORY_HUB_PATHS = Object.keys(CATEGORY_LABELS).map(cat => `/tools/category/${cat}`);

export const ALL_SITEMAP_ROUTES = [...new Set([...CORE_SEO_ROUTES, ...TOOL_SEO_INDEXABLE_ROUTES, ...PROGRAMMATIC_SEO_PATHS, ...COMPARISON_SEO_PATHS, ...ALTERNATIVE_SEO_PATHS, ...CATEGORY_HUB_PATHS])];

export const findToolSeoRoute = (pathname) => {
  if (TOOL_SEO_ROUTE_MAP[pathname]) {
    return TOOL_SEO_ROUTE_MAP[pathname];
  }

  const directMatch = TOOL_SEO_ROUTES.find((route) => {
    const pattern = new RegExp(`^${escapeRegExp(route.path)}$`);
    return pattern.test(pathname);
  });

  return directMatch || null;
};
